// extracted by mini-css-extract-plugin
module.exports = {"subTitle_placeholder":"SubTitle_subTitle_placeholder__fC8n9","subTitleBold":"SubTitle_subTitleBold__3Jcxf"};